import { apiPath } from '@codot/contracts';
import { request } from './http';

/** The customer CMS only ends a Displaro support visit; everything else lives in the admin app (apps/admin). */
export const adminApi = {
  endSupport: () => request('POST', apiPath('adminSupportEnd'), null),
};
